import React from "react";
import { CustomizerLabelData } from "../types/ProductCustomizer";

export const RadioButton = ({ id, name, labelData, value, onChange, checked, className }: { id: string, name: string, labelData: CustomizerLabelData, value: string, onChange: Function, checked: boolean, className: string }) => {
  
  
  return (
    <div id={`RadioButton-${id}`} className={`py-[6px] relative ${className}`}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        checked={checked}
        className="appearance-none absolute opacity-0 peer"
      />
      <label htmlFor={id} className="min-h-[4.25rem] flex items-center justify-between gap-[12px] border border-blush-200 p-[20px] rounded-xl bg-white peer-checked:border-black peer-checked:bg-blush-200 leading-none transition-colors duration-300">
        {labelData.image &&
          <img src={labelData.image} alt={name} className="h-7 w-7" />
        }
        <div className="flex items-center justify-between basis-[100%]">
          <div className="">
            <p className="text-base font-medium">{labelData.title}</p>
            {labelData.description && <p className="text-[13px] mt-[8px] leading-4">{labelData.description}</p>}
          </div>

          {labelData.price_diff &&
            <span className="text-xs ml-[8px] bg-blush-100 font-medium py-[6px] px-[10px] rounded-sm">
              +{labelData.price_diff}
            </span>
          }
        </div>

        <div className="basis-[24px]">
          {checked &&
            <svg focusable="false" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#117456"/>
              <path d="M11.0004 13.5858L15.5964 8.98926L16.3039 9.69626L11.0004 14.9998L7.81836 11.8178L8.52536 11.1108L11.0004 13.5858Z" fill="white"/>
            </svg>
          }
        </div>
      </label>
    </div>
  )
};